import * as React from "react"
import {Icon} from "semantic-ui-react"
import {PassengerFormData} from "../model/passenger/types"

const pointerStyle = {
  cursor: "pointer",
}

interface OptionalTextProps {
  text: string | null
  onClick: () => void
}

function OptionalText(props: OptionalTextProps) {
  const {text, onClick} = props
  if (text !== null && text.length > 0) {
    return (
      <span style={pointerStyle} onClick={onClick}>
        {", " + text}
      </span>
    )
  }
  return <span />
}

interface Props {
  passenger: PassengerFormData
  onDelete: (() => void) | null
  onEdit: (() => void) | null
  disabled: boolean
}

const spacerStyle = {
  display: "inline-block",
  width: "10px",
}

export function Passenger(props: Props) {
  const {
    onEdit,
    onDelete,
    passenger: {name, email, mobile, phone},
    disabled,
  } = props

  return (
    <div>
      {onDelete && (
        <>
          <Icon link={!disabled} onClick={onDelete} disabled={disabled} name="close" color="grey" />
          <span style={spacerStyle} />
        </>
      )}
      <span style={pointerStyle} onClick={onEdit || noop}>
        {name}
      </span>
      <OptionalText text={email} onClick={onEdit || noop} />
      <OptionalText text={mobile} onClick={onEdit || noop} />
      <OptionalText text={phone} onClick={onEdit || noop} />
      <span style={spacerStyle} />
      {onEdit && (
        <Icon link={!disabled} onClick={onEdit} disabled={disabled} name="write" color="grey" />
      )}
    </div>
  )
}

const noop = () => void 0



// WEBPACK FOOTER //
// ./src/components/Passenger.tsx